// Countdown time constants (in seconds)
export const QR_REFRESH_TIME = 50
export const DEFAULT_COUNTDOWN_TIME = 60
export const SHORT_COUNTDOWN_TIME = 30
export const LONG_COUNTDOWN_TIME = 120
